module.exports = __webpack_public_path__ + "static/media/grao.feb0a182.jpg";